import { type FC } from "react";

import { Copyright } from "./copyright";

export const Footer: FC = () => (
  <footer className="flex items-center justify-center">
    <Copyright />
  </footer>
);
